// If you choose to supply only some of these, you get best coverage of most
// devices using 192 and 512
export enum ChromeTileWidths {
    Smallest = 36,
    Smaller = 48,
    Small = 72,
    MediumIsh = 96,
    Medium = 144,
    MediumEst = 192, // Recommended
    Large = 256,
    Larger = 384,
    Largest = 512, // Recommended
}

// If you choose to supply only some of these, you get best coverage of most
// devices using 180 alone
export enum AppleTouchIcons {
    Smallest = 57,
    Smaller = 60,
    Small = 72,
    MediumIsh = 76,
    Medium = 114,
    MediumEst = 120,
    Large = 144,
    Larger = 152,
    Largest = 180, // Recommended
}

export type FaviconLink = {
    sizes: string;
    href: string; // never null or undefined but could be empty string
};

// Used on Windows 8.1, Windows 10, Internet Explorer 11 and Edge Browser
// If you choose to supply only some of these, you get best coverage of most
// devices using 150 alone
export enum Win81_Win10_IE11_Edge_TileWidths {
    Small = 70,
    Medium = 150, // Recommended
    Large = 310,
}

// Used on Windows 8.0 and Internet Explorer 10
export enum Win8_IE10_TileWidths {
    Medium = 144, // Recommended
}

// If you choose to supply only some of these, you get best coverage of most
// devices using 16 and 32
export enum FavIconPngs {
    /**
     * DO NOT CHANGE THE ORDER!!!
     * ExtraLarge must appear above large I believe (see the faq link below)
     * The others I don't think matter but we are maintaining the order from realfavicongenerator.net
     */
    Medium = 32, // Recommended
    ExtraLarge = 194, // https://realfavicongenerator.net/faq#extra_large_png_icon
    Large = 192,
    Small = 16, // Recommended
}
